import { useUnifiedAuth } from 'components/Common/UnifiedAuthContext';
import PageLoader from 'pages/Authentication/components/PageLoader';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { landing } from 'utils/spaUrls';

export default function Login() {
  const { isLoading, isAuthenticated, loginWithRedirect } = useUnifiedAuth();

  React.useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      loginWithRedirect();
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isAuthenticated) {
    return <Navigate to={landing} />;
  }

  return (
    <PageLoader />
  );
}
